<template>
      <v-card class="card-shadow" @click="addCart(source)">
        <v-img
          src="/assets/no-image.jpg"
          class="white--text align-end"
          height="120px"
          gradient="to bottom, rgba(0,0,0,.1), rgba(0,0,0,.1)"
        >
          <v-card-title>
            <v-list>
              <v-list-item>
                <v-list-item-content>
                  <v-list-item-title class="text-h6" style="width:100% !important;font-size: 1.1rem !important;white-space:normal !important;word-break:break-all !important">
                    {{ source.item_name }}
                  </v-list-item-title>
                  <v-list-item-subtitle style="font-size: .9rem !important;">Kes.{{ source.price | currency('') }}</v-list-item-subtitle>
                  <v-list-item-subtitle style="font-size: 1rem !important;">
                      <div class="qnty" v-if="source.current_stock == null">{{ source.quantity }}</div>
                      <div class="qnty" v-if="source.current_stock != null && source.current_stock != 0">{{ source.current_stock }}</div>
                      <div class="qnty" v-if="source.current_stock != null && source.current_stock == 0"  :style="[source.current_stock == 0 ? {'width': '100%', 'color':'#E3AF00'} : {'width': '40px'}]">Out of Stock</div>
                  </v-list-item-subtitle>
                </v-list-item-content>

              </v-list-item>
            </v-list>
          </v-card-title>
        </v-img>
      </v-card> 
</template>

<script>
import { mapGetters } from 'vuex'
import axios from 'axios'

export default {
  name: 'Item',
  props: {
    index: { // index of current item
      type: Number
    },
    source: { // here is: {uid: 'unique_1', text: 'abc'}
      type: Object,
      default () {
        return {}
      }
    }
  },
  methods: {
 
  }
}
</script>